import { GeneralFieldValidationStatus } from "../../../common/async-validation-indicator/async-validation-indicator.component";

export const userManagementFormPersonalDetailsMessages: Record<
  string,
  Record<keyof typeof GeneralFieldValidationStatus, string>
> = {
  userName: {
    NoInfo: "",
    Valid: "שם המשתמש זמין",
    Invalid: "שם המשתמש כבר בשימוש",
    InvalidStructure: "יש לשתמש רק באותיות קטנות באנגלית ומקפים, לפחות 3 תווים",
    Pending: "שם המשתמש בבדיקה",
    Missing: "שדה חובה",
  },
  phoneNumber: {
    NoInfo: "",
    Valid: "מספר הטלפון זמין",
    Invalid: "מספר הטלפון כבר בשימוש",
    InvalidStructure: "מספר הטלפון אינו תקין",
    Pending: "מספר הטלפון בבדיקה",
    Missing: "שדה חובה",
  },
  email: {
    NoInfo: "",
    Valid: "כתובת האימייל זמינה",
    Invalid: "כתובת האימייל כבר בשימוש",
    InvalidStructure: "כתובת האימייל אינה תקינה",
    Pending: "כתובת האימייל בבדיקה",
    Missing: "שדה חובה",
  },
  israeliId: {
    NoInfo: "",
    Valid: "מספר תעודת הזהות זמין",
    Invalid: "תעודת הזהות כבר בשימוש",
    InvalidStructure: "תעודת הזהות אינה תקינה",
    Pending: "תעודת הזהות בבדיקה",
    Missing: "שדה חובה",
  },
};



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-form-personal-details/user-management-form-personal-details-messages.ts